import { createMuiTheme } from '@material-ui/core';

import defaultTheme from './default';
import newTheme from './newTheme';
import overrides from './overrides';
import { ITheme } from '../typings/theme';

export default {
  default: createMuiTheme({ ...defaultTheme, ...overrides, ...newTheme }) as ITheme,
};
